module.exports = __webpack_public_path__ + "img/flexi_life_logo.8294ff5d.webp";